import { lazy, Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PublicRoute } from 'routing/components'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const StatusRoute = lazy(
  () => import(/* webpackChunkName: "Status" */ 'modules/Status/pages/Status')
)

const StatusRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <PublicRoute exact path={routes.root} component={StatusRoute} />
      <Redirect path='*' to='/' />
    </Switch>
  </Suspense>
)

export default StatusRouting
